/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import e from "../TimeExtent.js";
import o from "../Viewpoint.js";
import r from "../core/Error.js";
import { IdentifiableMixin as i } from "../core/Identifiable.js";
import { JSONSupport as n } from "../core/JSONSupport.js";
import { clone as s } from "../core/lang.js";
import p from "../core/Logger.js";
import { property as m } from "../core/accessorSupport/decorators/property.js";
import { cast as a } from "../core/accessorSupport/decorators/cast.js";
import { reader as l } from "../core/accessorSupport/decorators/reader.js";
import { subclass as c } from "../core/accessorSupport/decorators/subclass.js";
import { writer as u } from "../core/accessorSupport/decorators/writer.js";
import { ensureType as w } from "../core/accessorSupport/ensureType.js";
import { SlideThumbnail as h } from "../webdoc/support/SlideThumbnail.js";
var y;
let d = y = class extends i(n) {
  constructor(t) {
    super(t), this.name = null, this.thumbnail = new h(), this.timeExtent = null;
  }
  castThumbnail(t) {
    return "string" == typeof t ? new h({
      url: t
    }) : w(h, t);
  }
  set viewpoint(t) {
    const {
      targetGeometry: e,
      scale: o
    } = t;
    null != e && "point" === e.type && null == o && p.getLogger(this).warn("Bookmark.viewpoint should include 'scale' when its targetGeometry is a point.", t), this._set("viewpoint", t);
  }
  readViewpoint(t, e) {
    const {
      extent: r,
      viewpoint: i
    } = e;
    return o.fromJSON(i || {
      targetGeometry: r
    });
  }
  writeViewpoint(t, e, o, i) {
    if (!t) return;
    const {
      targetGeometry: n
    } = t;
    if (null == n || "extent" === n.type) null != n && (e.extent = n.toJSON()), e[o] = t.toJSON();else {
      const t = "Bookmark.viewpoint cannot be written to JSON when the viewpoint's targetGeometry is not an extent.";
      i?.messages ? i.messages.push(new r("property:unsupported", t)) : p.getLogger(this).error(t);
    }
  }
  clone() {
    return new y(s({
      name: this.name,
      thumbnail: this.thumbnail,
      timeExtent: this.timeExtent,
      viewpoint: this.viewpoint
    }));
  }
};
t([m({
  type: String,
  nonNullable: !0,
  json: {
    write: {
      isRequired: !0
    }
  }
})], d.prototype, "name", void 0), t([m({
  type: h,
  json: {
    write: {
      overridePolicy: t => ({
        enabled: !(!t || !t.url)
      })
    }
  }
})], d.prototype, "thumbnail", void 0), t([a("thumbnail")], d.prototype, "castThumbnail", null), t([m({
  type: e,
  json: {
    write: !0
  }
})], d.prototype, "timeExtent", void 0), t([m({
  type: o,
  nonNullable: !0,
  json: {
    write: !0
  }
})], d.prototype, "viewpoint", null), t([l("viewpoint", ["extent", "viewpoint"])], d.prototype, "readViewpoint", null), t([u("viewpoint")], d.prototype, "writeViewpoint", null), d = y = t([c("esri.webmap.Bookmark")], d);
const f = d;
export { f as default };